import React from 'react'
import './Nav.css'

const Nav = () => {
  return (
    <>
      <div className="bg-[#2c3e50] text-white  h-[45px]  flex items-center nav-main overflow-x-auto scrollbar-hide hidden md:flex">
        <ul className="flex gap-4 items-center  font-semibold text-sm whitespace-nowrap px-4">
          <li className="border-b-2 border-transparent">HOME</li>
          <li className="border-b-2 border-transparent">LOTTERY</li>
          <li className="border-b-2 border-transparent">CRICKET</li>
          <li className="border-b-2 border-transparent">TENNIS</li>
          <li className="border-b-2 border-transparent">FOOTBALL</li>
          <li className="border-b-2 border-transparent">TABLE TENNIS</li>
          <li className="border-b-2 border-transparent">BACCARAT</li>
          <li className="border-b-2 border-transparent">32 CARDS</li>
          <li className="border-b-2 border-transparent">TEENPATTI</li>
          <li className="border-b-2 border-transparent">POKER</li>
          <li className="border-b-2 border-transparent">LUCKY 7</li>
        </ul>
      </div>
    </>
  );
};


export default Nav